import styles from '../../EntityPicker.module.scss';

import { Stack, Theme, Typography, useMediaQuery } from '@mui/material';
import { DateTime } from 'luxon';

import { EntityPickerColumnsVisibilityItem } from '@work4all/data/lib/settings/settings';

import { Contract } from '@work4all/models/lib/Classes/Contract.entity';
import { DeliveryNote } from '@work4all/models/lib/Classes/DeliveryNote.entity';
import { InboundDeliveryNote } from '@work4all/models/lib/Classes/InboundDeliveryNote.entity';
import { Order } from '@work4all/models/lib/Classes/Order.entity';

import { DateTimeCustom } from '@work4all/utils/lib/date-utils/formatDateString';

import { Tooltip } from '../../../tooltip/Tooltip';
import { getGridSizes } from '../../hooks/use-picker-settings';

type ErpEntity = Contract | DeliveryNote | Order | InboundDeliveryNote;

type ERPColumnSelectorProps = {
  item: ErpEntity;
  columnSettings: EntityPickerColumnsVisibilityItem[];
};

export const ERPColumnSelector = (props: ERPColumnSelectorProps) => {
  const { item, columnSettings } = props;

  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );

  return !isMobile ? (
    <Stack
      flexDirection="row"
      display="grid"
      gap={0.5}
      gridTemplateColumns={getGridSizes(columnSettings)}
    >
      {columnSettings.map(
        (column) =>
          column.isVisible && (
            <Tooltip
              key={column.key}
              title={formatERPColumnValue(column.key, item)}
              showOnlyOnOverflow
              enterNextDelay={1000}
            >
              <Typography
                key={column.key}
                variant="body2"
                noWrap
                flex="1"
                className={styles.secondaryInfo}
              >
                {formatERPColumnValue(column.key, item)}
              </Typography>
            </Tooltip>
          )
      )}
    </Stack>
  ) : null;
};

const formatERPColumnValue = (key: string, item: ErpEntity) => {
  if (key === 'date' || key === 'contractDate') {
    return item[key] && DateTime.fromISO(item[key]).isValid
      ? DateTime.fromISO(item[key]).toLocaleString(DateTimeCustom.DATE_SHORT)
      : '';
  } else if (key === 'projectName') {
    return item?.project?.name ?? '';
  } else if (key === 'projectNumber') {
    return item?.project?.number ?? '';
  } else if (key === 'businessPartnerName') {
    return (
      item?.businessPartnerContactCombined?.businessPartner?.data?.name ?? ''
    );
  } else if (key === 'businessPartnerNumber') {
    return (
      item?.businessPartnerContactCombined?.businessPartner?.data?.number ?? ''
    );
  } else {
    return item[key] ?? '';
  }
};
